const OUT_OF_CREDIT_ERROR_TYPES = {
    EMAIL: 'EMAIL_CREDIT-LIMIT',
    PHONE: 'PHONE_CREDIT-LIMIT',
    BOTH: 'BOTH_CREDIT-LIMIT',
    OVER_USE_PHONE: 'PHONE_NOT-ENOUGH-CREDITS',
    OVER_USE_EMAIL: 'EMAIL_CREDIT-LIMIT-CREDITS',
};
export { OUT_OF_CREDIT_ERROR_TYPES };
